package org.zest.insan_360_website.utils

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
fun rememberViewportWidth(): Int {
    var width by remember { mutableStateOf(window.innerWidth) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { width = window.innerWidth }
        window.addEventListener("resize", listener)

        onDispose {
            window.removeEventListener("resize", listener)
        }
    }

    return width
}

const val SM = 480
const val MD = 768
const val LG = 992
const val XL = 1280